import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="tint" title="Preguntas frecuentes" data-id="element-61" data-mp="1gcpfsz39k8rr">
      <ul className="mx-auto max-w-4xl space-y-3" data-id="element-62" data-mp="1ge8u4k5d09qw">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-gray-200" data-id="element-63" data-mp="291ml81mdmb33" data-mpi={index}>
              <h3 data-id="element-64" data-mp="240fc9z8hz5uu">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-out hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-blue-200 md:px-7" data-id="element-65" data-mp="244366zhutua3">
                  <span className="text-lg font-extrabold tracking-tight text-gray-900" data-id="element-66" data-mp="uhaknusc4qrq">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-blue-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-67" data-mp="flus5u7el2xg" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-68" data-mp="bjzmkdifw3dv">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-69" data-mp="3swjyd2ji0pog">
                    <p className="px-5 pb-6 text-lg text-gray-600 md:px-7" data-id="element-70" data-mp="1uhcod8hvxi5v">{faq.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}